module.exports = __webpack_public_path__ + "static/media/google.bbe3a3e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/google.jpg
// module id = 440
// module chunks = 0